export const Colors = {
  Neutrals: {
    BLACK: '#000000',
    LIGHT_GRAY: '#F0F0F0',
    DARK: '#676767',
    WHITE: '#FFFFFF',
  },
  Secondary: {
    LIGHT_BLUE: '#D0F4FF',
    NAVY: '#305C9D',
    MAROON: '#9D3030',
    GREEN: '#309D3B',
  },
};
